import { render, staticRenderFns } from "./TrendMainImage.vue?vue&type=template&id=12a6dcc9&scoped=true&name=trend-main-image&"
import script from "./TrendMainImage.vue?vue&type=script&lang=js&"
export * from "./TrendMainImage.vue?vue&type=script&lang=js&"
import style0 from "./TrendMainImage.vue?vue&type=style&index=0&id=12a6dcc9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a6dcc9",
  null
  
)

export default component.exports